export enum SUBSCRIPTION_STATUS {
  ACTIVE = 'active',
  CANCELED = 'canceled',
  CANCELLED = 'cancelled',
  INCOMPLETE = 'incomplete',
  INCOMPLETE_EXPIRED = 'incomplete_expired',
  PAST_DUE = 'past_due',
  PAUSED = 'paused',
  TRIALING = 'trialing',
  UNPAID = 'unpaid',
  //add cus
  NOT_SUBSCRIBED = 'not_subscribed',
  SUBSCRIBED = 'subscribed',
  OFF_PLATFORM_SUBSCRIPTION = 'off_platform_subscription',
}
